import dayjs from 'dayjs'

const DATE_FORMAT = 'YYYY-MM-DD'

export const DEFAULT_REPORT = {
  name: '',
  comment: '',
  report: {
    signedContractPriceCents: {},
    adjustmentOfPriceCents: {},
    paidValueCents: {},
    variations: [],
    topics: [],
    parts: []
  }
}

export const EMPTY_PAYMENT_SUBMILESTONE = {
  name: '',
  description: '',
  percentOfContractPrice: null,
  percentOfMilestone: null,
  paymentAmount: 0,
  originalDate: '',
  comment: '',
  purchaseOrder: ''
}

export const EMPTY_PAYMENT_MILESTONE = {
  name: '',
  description: '',
  percentOfContractPrice: '',
  paymentAmount: '',
  originalDate: '',
  comment: '',
  purchaseOrder: ''
}

export const DEFAULT_PAYMENT_APPLICATION = {
  name: '',
  description: '',
  paymentCertificate: '',
  invoiceReference: '',
  paymentAmount: 0,
  applicationDate: '',
  comment: '',
  paymentMilestones: []
}

export const DEFAULT_PART = {
  name: '',
  ratio: 100,
  purchaseOrder: '',
  currency: 'EUR',
  signedPriceCents: 0,
  currentPriceCents: 0
}
export const DEFAULT_CONTRACT = {
  employer: {},
  contractor: {},
  project: {},
  subContracts: []
}

export const BASE_WORKFLOW_STEP = {
  name: 'Application date',
  id: -1
}

export const PREVIOUS_WORKFLOW_STEP = {
  name: 'Previous step',
  id: null
}

export const EMPTY_WORKFLOW_STEP = {
  name: '',
  dueInDays: 1,
  notifications: [],
  order: null,
  calculationBase: PREVIOUS_WORKFLOW_STEP
}

export const EMPTY_WORKFLOW = {
  name: '',
  workflowSteps: [{
    name: '',
    dueInDays: 1,
    notifications: [],
    calculationBase: BASE_WORKFLOW_STEP
  }]
}

const defaultAmendment = {
  id: null,
  no: '',
  name: '',
  description: '',
  changeDescription: '',
  status: 'DRA',
  receivedDate: dayjs().format(DATE_FORMAT),
  referenceNumber: '',
  category: '',
  type: null,
  revisionHistory: [],
  stage: 0,
  workstream: null,
  reportingSide: 'employer'
}

const defaultVariation = {
  id: null,
  no: '',
  name: '',
  description: '',
  changeDescription: '',
  status: 'PEN',
  receivedDate: dayjs().format(DATE_FORMAT),
  referenceNumber: '',
  category: '',
  type: null,
  revisionHistory: [],
  stage: 0,
  workstream: null,
  partId: null
}
export const DEFAULT_VARIATION = {
  variation: defaultVariation,
  claim: defaultVariation,
  amendment: defaultAmendment,
  early_warning: defaultAmendment
}

export const DEFAULT_GUARANTEE = {
  name: '',
  no: '',
  status: 'ACT',
  guarantorName: '',
  guarantorRating: '',
  guarantorContractRating: '',
  securedAmountCents: 0,
  securedAmountPercent: 0,
  physicalStorage: '',
  internalContact: '',
  externalContact: '',
  sentBack: '',
  returnAddress: '',
  documentUrl: ''
}

export const DEFAULT_LD = {
  name: '',
  milestoneName: '',
  description: '',
  status: '',
  originalDate: null,
  eot: 0,
  amendedCompletionDate: null,
  actualCompletionDate: null,
  delay: 0,
  totalValueCents: 0,
  capValueCents: 0,
  partId: null,
  documentUrl: ''
}

export const DEFAULT_LD_DATE = {
  name: '',
  description: '',
  date: null
}

export const DEFAULT_PAYMENT_CERTIFICATE = {
  deductionCumulativeCents: null,
  deductionCumulativePreviousCents: null,
  deductionPaymentCents: null,
  deductionPercent: null,
  deductionTotalCents: null,
  onHoldCumulativeCents: null,
  onHoldCumulativePreviousCents: null,
  onHoldPaymentCents: null,
  onHoldPercent: null,
  onHoldTotalCents: null,
  optionNo: '',
  paymentCertificateRows: [],
  retentionCumulativeCents: null,
  retentionCumulativePreviousCents: null,
  retentionPaymentCents: null,
  retentionPercent: null,
  retentionTotalCents: null,
  statementDate: dayjs().format(DATE_FORMAT),
  variationNo: ''
}

export const DEFAULT_PAYMENT_CERTIFICATE_ROW = {
  cumulativeCents: 0,
  cumulativePreviousCents: 0,
  paymentCents: 0,
  percent: 0,
  totalCents: 0,
  type: ''
}

export const LD_STATUSES = ['Notice issued', 'LDs claimed', 'LDs paid', 'LDs waived', 'LDs settled']
